import { render, staticRenderFns } from "./salaryInfo.vue?vue&type=template&id=c7418f80&scoped=true&"
import script from "./salaryInfo.vue?vue&type=script&lang=js&"
export * from "./salaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./salaryInfo.vue?vue&type=style&index=0&id=c7418f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7418f80",
  null
  
)

export default component.exports